<template>
  <input type="text" class="rounded-2xl" v-model="value" />
</template>

<script>
import _ from "lodash";
export default {
  props: ["modelValue"],
  emits: ["update:modelValue"],
  computed: {
    value: {
      get() {
        return `${this.modelValue}€`;
      },
      set(value) {
        this.$emit("update:modelValue", _.replace(value, /[^\d.-]/g, ""));
      }
    }
  }
};
</script>
